import ErrorHandler from '@schachermayer/sch-vuejs-commons/src/errors';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { AppBarConfigurationApi } from '../../../build/swagger-code-extranet-api-definition';
import { AppBarConfiguration } from '../../../build/swagger-code-extranet-api-definition/models';

const configurationApi: AppBarConfigurationApi = new AppBarConfigurationApi({ basePath: process.env.VUE_APP_CONTEXT_BASE });

@Module({
    namespaced: true,
    name: 'extranetConfiguration',
})
export default class ExtranetConfigurationStoreModule extends VuexModule {
    appBarConfiguration: AppBarConfiguration = {
        enableNotificationCenter: false,
        showNetPrice: false,
    };

    @Mutation
    storeAppBarConfiguration(appBarConfiguration: AppBarConfiguration) {
        this.appBarConfiguration = appBarConfiguration;
    }

    @Action({ commit: 'storeAppBarConfiguration', rawError: true })
    async loadAppBarConfiguration(): Promise<AppBarConfiguration> {
        try {
            return (await configurationApi.getAppBarConfiguration({ credentials: 'same-origin' })).data;
        } catch (error) {
            ErrorHandler.handleError(error);
            return {};
        }
    }
}
